
import { VenueTasks } from '../VenueTasks';
export class VenueTasksOrgPartner extends VenueTasks {

  constructor(props) {
    super(props, {pageForOrgType: 'PARTNER'})
    this.noAdd = true
  }
}


// WEBPACK FOOTER //
// ./src/screens/admin/partners/VenueTasksOrgPartner.js